import API from '../../../API';
import ActionTypes from '../../actionTypes';
/**
 * Action creator for the fetch newspaper GET request
 */
var fetchNewspaperByPublicationIdAndDateGetRequest = function () { return ({
    type: ActionTypes.FETCH_NEWSPAPER_GET_REQUEST,
}); };
/**
 * Action creator for the fetch newspaper GET response
 */
var fetchNewspaperByPublicationIdAndDateGetResponse = function (data) { return ({
    type: ActionTypes.FETCH_NEWSPAPER_GET_RESPONSE,
    payload: data,
}); };
/**
 * Action creator for the fetch newspaper GET invalidate
 */
var fetchNewspaperByPublicationIdAndDateGetInvalidate = function (error) { return ({
    type: ActionTypes.FETCH_NEWSPAPER_GET_INVALIDATE,
    error: error,
}); };
/**
 * Returns a function that fetches a single newspaper from the newspapers API by its id and date
 * (we need both to get the correct newspaper, since we only have a publication id, not a newspaper id)
 * and performs the subsequent dispatch operations to send the data or the error to the store.
 */
var fetchNewspaperByPublicationIdAndDate = function (id, date) { return function (dispatch) {
    dispatch(fetchNewspaperByPublicationIdAndDateGetRequest());
    return API.getNewspaperByPublicationIdAndDate(id, date)
        .then(function (newspaper) { return dispatch(fetchNewspaperByPublicationIdAndDateGetResponse(newspaper)); })
        .catch(function (error) { return dispatch(fetchNewspaperByPublicationIdAndDateGetInvalidate(error.message)); });
}; };
export default fetchNewspaperByPublicationIdAndDate;
